import React, { useState, useContext, useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/auth';
import { showCustomToast, CustomToastContainer } from '../../components/CustomToast';
import logo from "../../assets/logo.png";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { FcGoogle } from "react-icons/fc"; // Import Google icon
import signImage from '../../assets/sign.png';
import login2 from "../../assets/login2.gif"




const Sign_in = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [auth, setAuth] = useAuth();
  const navigate = useNavigate();
  const [showContactPopup, setShowContactPopup] = useState(false);

  // Check if user is already logged in - Only run once on component mount
  useEffect(() => {
    // Check local storage directly rather than depending on auth state
    const storedAuth = localStorage.getItem('auth');
    if (storedAuth) {
      try {
        const parsedAuth = JSON.parse(storedAuth);
        if (parsedAuth && parsedAuth.token) {
          // Verify token is still valid (not expired) before redirecting
          const tokenParts = parsedAuth.token.split('.');
          if (tokenParts.length === 3) {
            const payload = JSON.parse(atob(tokenParts[1]));
            const expTime = payload.exp * 1000; // Convert to milliseconds

            if (expTime > Date.now()) {
              // Only update auth state if not already set
              if (!auth || !auth.token) {
                setAuth(parsedAuth);
              }
              // Use replace instead of push to prevent back button issues
              navigate('/dashboard/allServices', { replace: true });
            } else {
              // Token expired, clear it
              localStorage.removeItem('auth');
              localStorage.removeItem('token');
              setAuth({ user: null, token: null });
            }
          }
        }
      } catch (err) {
        console.error("Error parsing auth from localStorage:", err);
      }
    }
  }, []); // Empty dependency array - only run once on mount

  // Handle regular form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Regular sign-in handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch('https://api.makeeasydocuments.com/api/auth/signin', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      // if (data.error) {
      //   showCustomToast(data.error, "error");
      //   return;
      // }

      if (!data.success) {
        showCustomToast(data.message || 'Login failed', 'error');
        setIsLoading(false);
        return;
      }

      

      const tokenParts = data.token.split('.');
      if (tokenParts.length !== 3) {
        throw new Error('Invalid token format');
      }

      const payload = JSON.parse(atob(tokenParts[1])); // Decode token payload
      const userId = payload._id;
      const userRole = payload.role; // Extract role from token

      if (userRole === 0) {
        showCustomToast("Access denied: Unauthorized role", "error");
        return;
      }

      const userWithId = {
        ...data.user,
        _id: userId,
        role: userRole, // Ensure role is included in user object
      };

      // Save auth data atomically
      const authData = { user: userWithId, token: data.token };

      // Update local storage first
      localStorage.setItem('auth', JSON.stringify(authData));

      // Then update state
      setAuth(authData);

      // Navigate with replace to prevent back button issues
      setTimeout(()=>{
        navigate('/dashboard/allServices', { replace: true });
      },2000)
      showCustomToast('Logged in successfully!', 'success');
    } catch (err) {
      console.error("Error during sign in:", err);
      showCustomToast('Something went wrong!', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleSuccess = async (response) => {
    if (!response.credential) {
        console.error("Google credential missing");
        showCustomToast("Google login failed: Credential missing", "error");
        return;
    }

    try {
        const res = await fetch('https://api.makeeasydocuments.com/api/auth/google', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ credential: response.credential }),
        });
        https://api.makeeasydocuments.com/
        if (!res.ok) {
            const errorData = await res.json();
            const errorMessage = errorData.message || "Google authentication failed";
            throw new Error(errorMessage);
        }

        const data = await res.json();
        console.log("Google Auth Response:", data);

        if (data.token) {
            const userId = data.user._id;

            const userWithId = { ...data.user, _id: userId };

            setAuth({ user: userWithId, token: data.token });
            localStorage.setItem('auth', JSON.stringify({ user: userWithId, token: data.token }));

            const userCheckResponse = await fetch(`https://api.makeeasydocuments.com/api/auth/getgoogle/${userId}`);
            console.log(userCheckResponse)
            if (!userCheckResponse.ok) throw new Error("Failed to fetch user details");

            const userDetails = await userCheckResponse.json();

            if (!userDetails.contact) {
                setShowContactPopup(true);
            } else {
                navigate('/dashboard/allServices');
            }
        } else {
            showCustomToast(data.message || 'Google login failed', 'error');
        }
    } catch (error) {
        console.error('Google login error:', error);
        showCustomToast(error.message || 'Something went wrong with Google login!', 'error');
    }
};

  // Initialize Google Sign-In - Only once on component mount
  useEffect(() => {
    // Load Google API Script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    let googleInitialized = false;

    script.onload = () => {
      if (window.google && !googleInitialized) {
        googleInitialized = true;
        window.google.accounts.id.initialize({
          client_id: '588239284344-osr2rouk6lr9p5p5parmqv11m9pp42b3.apps.googleusercontent.com',
          callback: handleGoogleSuccess,
        });

        const googleButton = document.getElementById('googleSignIn');
        if (googleButton) {
          window.google.accounts.id.renderButton(
            googleButton,
            { theme: 'filled_blue', size: 'large', shape: 'rectangular' }
          );
        }
      }
    };

    return () => {
      // Clean up script on component unmount
      const loadedScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
      if (loadedScript) {
        document.body.removeChild(loadedScript);
      }
      // Cancel any Google sign-in processes
      if (window.google && window.google.accounts && window.google.accounts.id) {
        window.google.accounts.id.cancel();
      }
    };
  }, []); // Empty dependency array to run only once

  return (
    <div>

      <br /> <br /> <br />
      <div className="flex w-full max-w-sm mx-auto overflow-hidden bg-white !bg-white rounded-lg shadow-2xl lg:max-w-4xl">
        <div className="pt-24 hidden bg-cover lg:block lg:w-1/2">
          <img
            src={login2} // Use the imported image
            alt="login animation"
            className="w-30 h-30"
          />
        </div>


        <div className="w-full px-6 py-8 md:px-8 lg:w-1/2">
          <div className="flex justify-center mx-auto">
            <img className="h-20 w-30 mr-3" src={logo} alt=" Make Easy Documents Logo" />
          </div>
          <p className="mt-3 text-xl text-center text-black">
            Welcome back!
          </p>


          {/* Google Sign-In Button */}
          <div className="mt-4" style={{ height: "20px", width: "380px" }}>
            <div id="g_id_onload"
              data-client_id="YOUR_GOOGLE_CLIENT_ID"
              data-context="signin"
              data-callback="handleGoogleSuccess"
              data-auto_select="false"
              data-itp_support="true">
            </div>

            <div className="mt-4">
              <div id="googleSignIn"></div>
            </div>

          </div>



          <form onSubmit={handleSubmit}>
            <div className="mt-8">
              <label
                className="block mb-2 text-sm font-medium text-black"
                htmlFor="email"
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                className="block w-full px-4 py-2 text-black bg-white border rounded-lg !bg-white !text-black focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="mt-4">
              <div className="flex justify-between">
                <label
                  className="block mb-2 text-sm font-medium text-black"
                  htmlFor="password"
                >
                  Password
                </label>
                <Link
                  onClick={() => window.scrollTo(0, 0)}
                  to="/forgot_password"
                  className="text-xs text-black hover:underline"
                >
                  Forgot Password?
                </Link>
              </div>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  className="block w-full px-4 py-2 text-black bg-white border rounded-lg !bg-white !text-black focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="absolute right-2 top-2 text-black"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <AiFillEyeInvisible size={20} />
                  ) : (
                    <AiFillEye size={20} />
                  )}
                </button>
              </div>
            </div>

            <div className="mt-6">
              <button
                type="submit"
                className="w-full px-6 py-3 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-gray-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
              >
                Sign In
              </button>
            </div>
            {showContactPopup && <ContactPopup onClose={() => setShowContactPopup(false)} />}

          </form>


          <div className="flex items-center justify-between mt-4">
            <span className="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
            <Link onClick={() => window.scrollTo(0, 0)} to="/sign_up" className="text-xs text-gray-500 uppercase dark:text-gray-400 hover:underline">or sign up</Link>
            <span className="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
          </div>
        </div>
      </div>
      <br /> <br /> <br />
      <CustomToastContainer />
      <Footer />
    </div>
  );
};
const ContactPopup = ({ onClose }) => {
  const [contactNumber, setContactNumber] = useState('');
  const [auth] = useAuth();
  const navigate = useNavigate();

  const handleSaveContact = async () => {
    if (!/^\d+$/.test(contactNumber)) {
      showCustomToast("Please enter numbers only", "error");
      return;
    }

    const storedAuth = JSON.parse(localStorage.getItem("auth"));
    const userId = auth?.user?._id || storedAuth?.user?._id;
    const token = auth?.token || storedAuth?.token;

    if (!userId) {
      showCustomToast("User ID not found", "error");
      console.log("User ID missing");
      return;
    }

    try {
      const res = await fetch(`https://api.makeeasydocuments.com/api/auth/update-contact/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ contact: contactNumber }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        console.log("Failed to update contact:", errorData);
        throw new Error(errorData.message || "Failed to update contact");
      }

      showCustomToast('Contact number saved successfully!', 'success');
      onClose();
      console.log("Before navigation");

      navigate('/dashboard/allServices');

    } catch (error) {
      console.error("Error updating contact:", error);
      showCustomToast(error.message || 'Something went wrong!', 'error');
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 transition-opacity duration-300 ease-in-out">
      <div className="bg-white p-8 rounded-xl shadow-lg w-96 transform scale-95 transition-transform duration-300 ease-in-out">
        <h2 className="text-2xl font-semibold mb-4">Add Your Contact Number</h2>
        <input
          type="text"
          placeholder="Enter contact number"
          value={contactNumber}
          onChange={(e) => setContactNumber(e.target.value)}
          className="w-full p-3 border rounded-md mb-4 focus:outline-none focus:ring focus:ring-blue-300"
        />
        <button
          onClick={handleSaveContact}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-md transition-colors duration-200"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default Sign_in;